export const getIsLogoutOpenModal = state => state.modal.isLogoutOpenModal;
export const getIsDeleteOpenModal = state => state.modal.isDeleteOpenModal;
export const getDeleteId = state => state.modal.deleteId;
